import "./App.css";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import Main from "./components/Main";

function App() {
  return (
    <>
      <HeroSection />
      <Main />
      <Footer />
    </>
  );
}

export default App;
